/* ============================================
   INSCRIPTION USPEG - JAVASCRIPT v5
   ============================================ */

(function() {
  'use strict';

  const config = {
    totalSteps: 6,
    minorAge: 18
  };

  // Variantes Shopify — COTISATION (2 formules seulement)
  const VARIANT_IDS = {
    'decouverte': 53513737601362,
    'loisirs': 53513737634130
  };

  // Variantes Shopify — MAILLOT : 3 produits séparés, chacun avec ses tailles en variantes
  const MAILLOT_VARIANT_IDS = {
    homme: {
      '10 ans': 54331006386514,
      '12 ans': 54331006779730,
      '14 ans': 54331007172946,
      'S': 54331007566162,
      'M': 54331007959378,
      'L': 54331008352594,
      'XL': 54331008745810
    },
    junior_u6_u10: {
      '4 ans': 54331065729362,
      '6 ans': 54331065762130,
      '8 ans': 54331065794898,
      '10 ans': 54331065827666
    },
    debardeur_femme: {
      '10 ans': 54331052687698,
      '12 ans': 54331054653778,
      '14 ans': 54331054686546,
      'S': 54331054719314,
      'M': 54331054752082,
      'L': 54331054784850
    },
    brassiere_femme: {
      'S': 54331054817618,
      'M': 54331054850386
    }
  };

  const JERSEY_MODEL_LABELS = {
    homme: 'Maillot Homme',
    debardeur_femme: 'Débardeur Femme',
    brassiere_femme: 'Brassière Femme',
    junior_u6_u10: 'Maillot U6 / U10'
  };

  const JERSEY_SIZES = {
    homme: ['10 ans', '12 ans', '14 ans', 'S', 'M', 'L', 'XL'],
    debardeur_femme: ['10 ans', '12 ans', '14 ans', 'S', 'M', 'L'],
    brassiere_femme: ['S', 'M'],
    junior_u6_u10: ['4 ans', '6 ans', '8 ans', '10 ans']
  };

  // Catégories FFA considérées "U6-U10" pour le maillot enfant
  const JERSEY_JUNIOR_CATEGORIES = ['ecole', 'baby'];

  const ffaCategories = [
    { value: 'master', label: 'Master (MA)', yearMin: 0, yearMax: 1992 },
    { value: 'senior', label: 'Senior (SE)', yearMin: 1993, yearMax: 2004 },
    { value: 'espoir', label: 'Espoir (U23)', yearMin: 2005, yearMax: 2007 },
    { value: 'junior', label: 'Junior (U20)', yearMin: 2008, yearMax: 2009 },
    { value: 'cadet', label: 'Cadet (U18)', yearMin: 2010, yearMax: 2011 },
    { value: 'minime', label: 'Minime (U16)', yearMin: 2012, yearMax: 2013 },
    { value: 'benjamin', label: 'Benjamin (U14)', yearMin: 2014, yearMax: 2015 },
    { value: 'poussin', label: 'Poussin (U12)', yearMin: 2016, yearMax: 2017 },
    { value: 'ecole', label: 'École d\'athlétisme (U10)', yearMin: 2018, yearMax: 2020 },
    { value: 'baby', label: 'Baby Athlé', yearMin: 2021, yearMax: 9999 }
  ];

  const pricingLabels = {
    decouverte: 'Découverte/Compétition',
    loisirs: 'Loisirs Running/Santé'
  };

  const requestTypeLabels = {
    renouvellement: 'Renouvellement',
    nouveau: 'Nouvel adhérent'
  };

  const paymentLabels = {
    cb_online: 'Carte bancaire en ligne',
    cheque: 'Chèque(s) bancaire(s)',
    especes: 'Espèces'
  };

  // ============================================
  // INIT
  // ============================================
  function initInscription(form) {
    const sectionId = form.id.replace('inscription-form-', '');
    const state = {
      currentStep: 1,
      sectionId: sectionId,
      uploads: {
        certificat: null, photo: null,
        identity_recto: null, identity_verso: null,
        residence: null, attestation: null, attestation_qs: null,
        parent_id_recto: null, parent_id_verso: null
      },
      age: null,
      birthYear: null,
      basePrice: 0,
      jerseyPrice: 0,
      passSportAmount: 0,
      carteJeuneAmount: 0,
      total: 0,
      requestType: null,
      isMinor: false,
      isForeigner: false,
      jerseyAdd: null,
      jerseyModel: null,
      jerseySize: null
    };

    setupNavigation(form, state);
    setupRequestType(form, state);
    setupNationality(form, state);
    setupBirthdateCalc(form, state);
    setupPricingCalc(form, state);
    setupAidsCalc(form, state);
    setupHealthChoice(form, state);
    setupJersey(form, state);
    setupValidation(form, state);
    setupUploadcare(form, state);
    setupSubmit(form, state);
    updateProgressBar(state);
  }

  // ============================================
  // NAVIGATION
  // ============================================
  function setupNavigation(form, state) {
    const btnPrev = form.querySelector('[data-action="prev"]');
    const btnNext = form.querySelector('[data-action="next"]');

    if (btnNext) {
      btnNext.addEventListener('click', function(e) {
        e.preventDefault();
        if (validateStep(form, state.currentStep, state)) {
          goToStep(form, state, state.currentStep + 1);
        }
      });
    }
    if (btnPrev) {
      btnPrev.addEventListener('click', function(e) {
        e.preventDefault();
        goToStep(form, state, state.currentStep - 1);
      });
    }
  }

  function goToStep(form, state, newStep) {
    if (newStep < 1 || newStep > config.totalSteps) return;

    const currentStepEl = form.querySelector('[data-step="' + state.currentStep + '"].inscription__step-' + state.sectionId);
    if (currentStepEl) currentStepEl.classList.remove('is-visible');

    const newStepEl = form.querySelector('[data-step="' + newStep + '"].inscription__step-' + state.sectionId);
    if (newStepEl) newStepEl.classList.add('is-visible');

    state.currentStep = newStep;
    updateProgressBar(state);
    updateNavButtons(form, state);

    if (newStep === 5) updateJerseyStepDisplay(form, state);
    if (newStep === 6) { recalcTotal(form, state); fillSummary(form, state); }

    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function updateProgressBar(state) {
    const indicators = document.querySelectorAll('.inscription-' + state.sectionId + ' .inscription__step-indicator-' + state.sectionId);
    const fill = document.querySelector('.inscription-' + state.sectionId + ' .inscription__progress-fill-' + state.sectionId);

    indicators.forEach(function(ind) {
      const stepNum = parseInt(ind.getAttribute('data-step'), 10);
      ind.classList.remove('is-active', 'is-completed');
      if (stepNum < state.currentStep) ind.classList.add('is-completed');
      else if (stepNum === state.currentStep) ind.classList.add('is-active');
    });

    if (fill) {
      const percentage = ((state.currentStep - 1) / (config.totalSteps - 1)) * 100;
      fill.style.width = 'calc(' + percentage + '% - ' + (percentage / 100 * 40) + 'px)';
    }
  }

  function updateNavButtons(form, state) {
    const btnPrev = form.querySelector('[data-action="prev"]');
    const btnNext = form.querySelector('[data-action="next"]');
    const btnSubmit = form.querySelector('[data-action="submit"]');

    if (btnPrev) btnPrev.style.display = state.currentStep > 1 ? 'inline-flex' : 'none';

    if (state.currentStep === config.totalSteps) {
      if (btnNext) btnNext.style.display = 'none';
      if (btnSubmit) btnSubmit.style.display = 'inline-flex';
    } else {
      if (btnNext) btnNext.style.display = 'inline-flex';
      if (btnSubmit) btnSubmit.style.display = 'none';
    }
  }

  // ============================================
  // TYPE DE DEMANDE — MUTATION = LIEN CONTACT (pas de redirection auto)
  // ============================================
  function setupRequestType(form, state) {
    const radios = form.querySelectorAll('input[name="request_type"]');
    const redirectNotice = form.querySelector('#mutation-redirect-' + state.sectionId);

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        state.requestType = this.value;

        if (this.value === 'mutation') {
          if (redirectNotice) redirectNotice.classList.add('is-visible');
          return;
        } else {
          if (redirectNotice) redirectNotice.classList.remove('is-visible');
        }

        updateQsSportAvailability(form, state);
      });
    });
  }

  function updateQsSportAvailability(form, state) {
    const availableBlock = form.querySelector('#quest-available-' + state.sectionId);
    const unavailableBlock = form.querySelector('#quest-unavailable-' + state.sectionId);

    const isAvailable = (state.requestType === 'renouvellement');
    if (availableBlock) availableBlock.style.display = isAvailable ? '' : 'none';
    if (unavailableBlock) unavailableBlock.style.display = isAvailable ? 'none' : 'block';
  }

  // ============================================
  // NATIONALITÉ
  // ============================================
  function setupNationality(form, state) {
    const select = form.querySelector('select[name="nationality"]');
    const foreignSection = form.querySelector('#foreign-section-' + state.sectionId);
    const uploadTitre = form.querySelector('#upload-titre-' + state.sectionId);

    if (!select) return;

    select.addEventListener('change', function() {
      state.isForeigner = (this.value === 'Autre');
      if (foreignSection) foreignSection.classList.toggle('is-visible', state.isForeigner);
      if (uploadTitre) uploadTitre.style.display = state.isForeigner ? '' : 'none';
    });
  }

  // ============================================
  // CALCUL CATÉGORIE FFA + MINEUR
  // ============================================
  function setupBirthdateCalc(form, state) {
    const birthdateInput = form.querySelector('input[name="birthdate"]');
    if (!birthdateInput) return;

    birthdateInput.addEventListener('change', function() {
      const date = new Date(this.value);
      if (isNaN(date.getTime())) return;

      const year = date.getFullYear();
      const age = calculateAge(date);

      const category = ffaCategories.find(function(c) { return year >= c.yearMin && year <= c.yearMax; });
      if (category) {
        const suggestionEl = form.querySelector('#category-suggestion-' + state.sectionId);
        const labelEl = form.querySelector('#suggested-category-' + state.sectionId);
        if (suggestionEl && labelEl) {
          labelEl.textContent = category.label;
          suggestionEl.classList.add('is-visible');
        }
        const select = form.querySelector('select[name="category"]');
        if (select) select.value = category.value;
      }

      const minorSection = form.querySelector('#minor-section-' + state.sectionId);
      const minorDocsSection = form.querySelector('#minor-docs-section-' + state.sectionId);
      const minorReglementNotice = form.querySelector('#minor-reglement-notice-' + state.sectionId);
      state.isMinor = (age < config.minorAge);

      if (minorSection) minorSection.classList.toggle('is-visible', state.isMinor);
      if (minorDocsSection) minorDocsSection.classList.toggle('is-visible', state.isMinor);
      if (minorReglementNotice) minorReglementNotice.classList.toggle('is-visible', state.isMinor);

      state.birthYear = year;
      state.age = age;

      updatePricingDisplay(form, state);
    });
  }

  function calculateAge(birthDate) {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
  }

  function updatePricingDisplay(form, state) {
    const minorBanner = form.querySelector('#minor-pricing-banner-' + state.sectionId);
    const pricingCards = form.querySelectorAll('.inscription__radio-card-' + state.sectionId + '[data-pricing-type]');

    pricingCards.forEach(function(card) {
      const type = card.getAttribute('data-pricing-type');
      const radio = card.querySelector('input[type="radio"]');
      if (state.isMinor && type === 'loisirs') {
        card.style.display = 'none';
        if (radio && radio.checked) radio.checked = false;
      } else {
        card.style.display = '';
      }
    });

    if (minorBanner) minorBanner.style.display = state.isMinor ? 'block' : 'none';
  }

  // ============================================
  // CALCUL PRIX COTISATION
  // ============================================
  function setupPricingCalc(form, state) {
    const pricingRadios = form.querySelectorAll('input[name="pricing"]');
    pricingRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        state.basePrice = parseFloat(this.getAttribute('data-price')) || 0;
      });
    });
  }

  // ============================================
  // AIDES (Pass'Sport + Carte Jeune Provence)
  // ============================================
  function setupAidsCalc(form, state) {
    const passSportCheckbox = form.querySelector('input[name="aid_passsport"]');
    const carteSelect = form.querySelector('select[name="aid_carte_jeune_provence"]');

    if (passSportCheckbox) {
      passSportCheckbox.addEventListener('change', function() {
        state.passSportAmount = this.checked ? 70 : 0;
      });
    }
    if (carteSelect) {
      carteSelect.addEventListener('change', function() {
        state.carteJeuneAmount = parseFloat(this.value) || 0;
      });
    }
  }

  // ============================================
  // CODES PROMO — appliqués automatiquement au checkout en ligne
  // ============================================
  const PASSSPORT_DISCOUNT_CODE = 'PassSport70';
  const CARTE_JEUNE_DISCOUNT_CODES = {
    5: 'CARTEJEUNE5', 10: 'CARTEJEUNE10', 15: 'CARTEJEUNE15', 20: 'CARTEJEUNE20',
    25: 'CARTEJEUNE25', 30: 'CARTEJEUNE30', 35: 'CARTEJEUNE35', 40: 'CARTEJEUNE40',
    45: 'CARTEJEUNE45', 50: 'CARTEJEUNE50', 55: 'CARTEJEUNE55', 60: 'CARTEJEUNE60',
    65: 'CARTEJEUNE65', 70: 'CARTEJEUNE70', 75: 'CARTEJEUNE75', 80: 'CARTEJEUNE80',
    85: 'CARTEJEUNE85', 90: 'CARTEJEUNE90', 95: 'CARTEJEUNE95', 100: 'CARTEJEUNE100'
  };

  function buildDiscountCodes(state) {
    const codes = [];
    if (state.passSportAmount > 0) codes.push(PASSSPORT_DISCOUNT_CODE);
    if (state.carteJeuneAmount > 0) {
      const code = CARTE_JEUNE_DISCOUNT_CODES[state.carteJeuneAmount];
      if (code) codes.push(code);
    }
    return codes;
  }

  // Applique les codes promo un par un en arrière-plan (fetch, pas de
  // navigation visible) : chaque appel à /discount/CODE pose le cookie de
  // réduction correspondant sans jamais bouger la page. Une fois tous les
  // codes traités, on navigue nous-mêmes vers /checkout — donc l'atterrissage
  // final est garanti, contrairement au chaînage de redirections Shopify qui
  // perd le paramètre "redirect" imbriqué en cours de route.
  function applyDiscountCodesSequentially(codes, index, callback) {
    if (index >= codes.length) {
      callback();
      return;
    }
    fetch('/discount/' + encodeURIComponent(codes[index]), { credentials: 'same-origin' })
      .then(function() {
        applyDiscountCodesSequentially(codes, index + 1, callback);
      })
      .catch(function() {
        // Un code en échec ne doit jamais bloquer le parcours : on continue
        // vers le suivant / le checkout plutôt que de laisser l'utilisateur coincé.
        applyDiscountCodesSequentially(codes, index + 1, callback);
      });
  }

  // ============================================
  // CHOIX SANTÉ
  // ============================================
  function setupHealthChoice(form, state) {
    const radios = form.querySelectorAll('input[name="health_type"]');
    const certSection = form.querySelector('#cert-section-' + state.sectionId);
    const questSection = form.querySelector('#quest-section-' + state.sectionId);

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (this.value === 'certificat') {
          if (certSection) certSection.classList.add('is-visible');
          if (questSection) questSection.classList.remove('is-visible');
        } else if (this.value === 'questionnaire') {
          if (questSection) questSection.classList.add('is-visible');
          if (certSection) certSection.classList.remove('is-visible');
        }
      });
    });
  }

  // ============================================
  // MAILLOT (étape 5) — modèle déduit auto (sexe + âge), taille manuelle
  // ============================================
  function populateJerseySizes(select, sizes) {
    if (!select) return;
    select.innerHTML = '<option value="">— Choisis une taille —</option>';
    (sizes || []).forEach(function(s) {
      const opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      select.appendChild(opt);
    });
  }

  function determineJerseyModel(form, state) {
    const categorySelect = form.querySelector('select[name="category"]');
    const category = categorySelect ? categorySelect.value : '';
    const genderRadio = form.querySelector('input[name="gender"]:checked');
    const gender = genderRadio ? genderRadio.value : '';

    if (JERSEY_JUNIOR_CATEGORIES.indexOf(category) !== -1) {
      return 'junior';
    }
    if (gender === 'H') return 'homme';
    if (gender === 'F') return 'femme';
    return 'unknown';
  }

  function setupJersey(form, state) {
    const femaleModelRadios = form.querySelectorAll('input[name="jersey_model_female"]');
    const sizeSelect = form.querySelector('#jersey-size-select-' + state.sectionId);

    femaleModelRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        state.jerseyModel = this.value;
        populateJerseySizes(sizeSelect, JERSEY_SIZES[this.value]);
        state.jerseySize = null;
      });
    });

    if (sizeSelect) {
      sizeSelect.addEventListener('change', function() { state.jerseySize = this.value; });
    }
  }

  function updateJerseyStepDisplay(form, state) {
    const autoBanner = form.querySelector('#jersey-auto-banner-' + state.sectionId);
    const autoText = form.querySelector('#jersey-auto-text-' + state.sectionId);
    const femaleChoice = form.querySelector('#jersey-female-choice-' + state.sectionId);
    const sizeSelect = form.querySelector('#jersey-size-select-' + state.sectionId);

    const detected = determineJerseyModel(form, state);

    if (detected === 'junior') {
      state.jerseyModel = 'junior_u6_u10';
      if (femaleChoice) femaleChoice.style.display = 'none';
      if (autoBanner) autoBanner.style.display = 'flex';
      if (autoText) autoText.textContent = 'Ton maillot : Maillot U6/U10 (déterminé selon ta date de naissance) — 15€';
      populateJerseySizes(sizeSelect, JERSEY_SIZES.junior_u6_u10);
    } else if (detected === 'homme') {
      state.jerseyModel = 'homme';
      if (femaleChoice) femaleChoice.style.display = 'none';
      if (autoBanner) autoBanner.style.display = 'flex';
      if (autoText) autoText.textContent = 'Ton maillot : Maillot Homme (déterminé automatiquement) — 30€';
      populateJerseySizes(sizeSelect, JERSEY_SIZES.homme);
    } else if (detected === 'femme') {
      if (autoBanner) autoBanner.style.display = 'none';
      if (femaleChoice) femaleChoice.style.display = 'block';
      if (state.jerseyModel !== 'debardeur_femme' && state.jerseyModel !== 'brassiere_femme') {
        state.jerseyModel = null;
        if (sizeSelect) sizeSelect.innerHTML = '<option value="">— Choisis Débardeur ou Brassière d\'abord —</option>';
      }
    } else {
      if (autoBanner) autoBanner.style.display = 'none';
      if (femaleChoice) femaleChoice.style.display = 'none';
    }
  }

  // ============================================
  // CALCUL DU TOTAL
  // ============================================
  function recalcTotal(form, state) {
    if (state.jerseyModel) {
      state.jerseyPrice = (state.jerseyModel === 'junior_u6_u10') ? 15 : 30;
    } else {
      state.jerseyPrice = 0;
    }

    const total = (state.basePrice || 0) + (state.jerseyPrice || 0) - (state.passSportAmount || 0) - (state.carteJeuneAmount || 0);
    state.total = Math.max(0, total);
  }

  // ============================================
  // VALIDATION
  // ============================================
  function setupValidation(form, state) {
    const inputs = form.querySelectorAll('[data-validate]');
    inputs.forEach(function(input) {
      input.addEventListener('blur', function() { validateField(input); });
      input.addEventListener('input', function() {
        const field = input.closest('.inscription__field-' + state.sectionId);
        if (field && field.classList.contains('has-error')) validateField(input);
      });
    });
  }

  function validateField(input) {
    const sectionId = input.closest('[id^="inscription-form-"]').id.replace('inscription-form-', '');
    const field = input.closest('.inscription__field-' + sectionId);
    if (!field) return true;

    const rule = input.getAttribute('data-validate');
    const value = input.value.trim();
    let valid = true;

    switch (rule) {
      case 'required': valid = value !== ''; break;
      case 'email': valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); break;
      case 'phone': valid = /^(\+33|0)[1-9](\s?\d{2}){4}$/.test(value.replace(/\s/g, '')); break;
      case 'postcode': valid = /^\d{5}$/.test(value); break;
    }

    field.classList.toggle('has-error', !valid);
    return valid;
  }

  function validateStep(form, stepNumber, state) {
    const sectionId = form.id.replace('inscription-form-', '');
    const stepEl = form.querySelector('[data-step="' + stepNumber + '"].inscription__step-' + sectionId);
    if (!stepEl) return true;

    let valid = true;

    const inputs = stepEl.querySelectorAll('[data-validate]');
    inputs.forEach(function(input) {
      if (!validateField(input)) valid = false;
    });

    const radioGroups = {};
    stepEl.querySelectorAll('input[type="radio"][required]').forEach(function(radio) {
      radioGroups[radio.name] = radioGroups[radio.name] || false;
      if (radio.checked) radioGroups[radio.name] = true;
    });
    for (const groupName in radioGroups) {
      if (!radioGroups[groupName]) valid = false;
    }

    if (stepNumber === 1) {
      if (!state.requestType) { alert('Merci de sélectionner le type de demande.'); return false; }
      if (state.requestType === 'mutation') {
        alert('Pour une mutation, merci de contacter directement le club via le lien affiché — cette demande ne se fait pas via ce formulaire.');
        return false;
      }
    }

    if (stepNumber === 3 && state.isMinor) {
      const parentName = form.querySelector('input[name="parent_name"]');
      const parentPhone = form.querySelector('input[name="parent_phone"]');
      const parentEmail = form.querySelector('input[name="parent_email"]');
      if (!parentName || !parentName.value.trim()) { alert('Merci de renseigner le nom du responsable légal.'); return false; }
      if (!parentPhone || !parentPhone.value.trim()) { alert('Merci de renseigner le téléphone du responsable légal.'); return false; }
      if (!parentEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(parentEmail.value.trim())) { alert('Merci de renseigner un email valide pour le responsable légal.'); return false; }
    }

    if (stepNumber === 4) {
      const healthType = form.querySelector('input[name="health_type"]:checked');
      if (!healthType) { alert('Merci de choisir : certificat médical OU attestation QS-SPORT.'); return false; }

      if (healthType.value === 'questionnaire') {
        if (state.requestType !== 'renouvellement') {
          alert('L\'attestation QS-SPORT n\'est disponible que pour les renouvellements. Merci de contacter directement le club (lien affiché) ou de choisir Certificat médical.');
          return false;
        }
      }

      if (!state.uploads.photo) { alert('Merci de téléverser ta photo d\'identité.'); return false; }

      if (!state.uploads.identity_recto || !state.uploads.identity_verso) {
        alert('Merci de téléverser le recto ET le verso de ta pièce d\'identité.');
        return false;
      }
      if (state.isForeigner && !state.uploads.residence) { alert('Merci de téléverser ton titre de séjour.'); return false; }

      if (state.isMinor) {
        if (!state.uploads.attestation) { alert('Merci de téléverser l\'attestation parentale.'); return false; }
        if (!state.uploads.parent_id_recto || !state.uploads.parent_id_verso) {
          alert('Merci de téléverser le recto ET le verso de la CNI du responsable légal.');
          return false;
        }
      }
    }

    if (stepNumber === 5) {
      if (!state.jerseyModel) {
        alert('Merci de choisir Débardeur ou Brassière.');
        return false;
      }
      if (!state.jerseySize) {
        alert('Merci de choisir une taille.');
        return false;
      }
    }

    if (stepNumber === 6) {
      const requiredChecks = stepEl.querySelectorAll('input[type="checkbox"][required]');
      let allChecked = true;
      requiredChecks.forEach(function(check) { if (!check.checked) allChecked = false; });
      if (!allChecked) { alert('Merci d\'accepter tous les engagements obligatoires pour finaliser ton inscription.'); return false; }
    }

    return valid;
  }

  // ============================================
  // UPLOADCARE
  // ============================================
  function setupUploadcare(form, state) {
    if (typeof uploadcare === 'undefined') {
      setTimeout(function() { setupUploadcare(form, state); }, 200);
      return;
    }

    const uploadInputs = form.querySelectorAll('input[role="uploadcare-uploader"]');
    uploadInputs.forEach(function(input) {
      const widget = uploadcare.Widget(input);
      const docKey = input.getAttribute('data-doc');
      const statusEl = form.querySelector('[data-status="' + docKey + '"]');

      widget.onUploadComplete(function(fileInfo) {
        state.uploads[docKey] = { uuid: fileInfo.uuid, name: fileInfo.name, url: fileInfo.cdnUrl };
        if (statusEl) statusEl.classList.add('is-uploaded');
      });
      widget.onChange(function(file) {
        if (!file) {
          state.uploads[docKey] = null;
          if (statusEl) statusEl.classList.remove('is-uploaded');
        }
      });
    });
  }

  // ============================================
  // RÉCAPITULATIF
  // ============================================
  function fillSummary(form, state) {
    const firstname = (form.querySelector('input[name="firstname"]') || {}).value || '';
    const lastname = (form.querySelector('input[name="lastname"]') || {}).value || '';
    const pricingRadio = form.querySelector('input[name="pricing"]:checked');
    const pricingLabel = pricingRadio ? (pricingLabels[pricingRadio.value] || pricingRadio.value) : '—';

    setSummary(form, 'name', (firstname + ' ' + lastname).trim() || '—');
    setSummary(form, 'pricing', pricingLabel + ' — ' + (state.basePrice || 0) + '€');

    const jerseyRow = form.querySelector('[data-summary-row="jersey"]');
    if (state.jerseyPrice > 0) {
      const modelLabel = JERSEY_MODEL_LABELS[state.jerseyModel] || '';
      setSummary(form, 'jersey', modelLabel + ' (' + state.jerseySize + ') — +' + state.jerseyPrice + '€');
      if (jerseyRow) jerseyRow.style.display = 'flex';
    } else if (jerseyRow) {
      jerseyRow.style.display = 'none';
    }

    const passSportRow = form.querySelector('[data-summary-row="passsport"]');
    if (state.passSportAmount > 0) {
      setSummary(form, 'passsport', '−' + state.passSportAmount + '€');
      if (passSportRow) passSportRow.style.display = 'flex';
    } else if (passSportRow) {
      passSportRow.style.display = 'none';
    }

    const carteRow = form.querySelector('[data-summary-row="cartejeune"]');
    if (state.carteJeuneAmount > 0) {
      setSummary(form, 'cartejeune', '−' + state.carteJeuneAmount + '€');
      if (carteRow) carteRow.style.display = 'flex';
    } else if (carteRow) {
      carteRow.style.display = 'none';
    }

    setSummary(form, 'total', (state.total || 0) + '€');
  }

  function setSummary(form, key, value) {
    const el = form.querySelector('[data-summary="' + key + '"]');
    if (el) el.textContent = value;
  }

  // ============================================
  // STATUT DU DOSSIER
  // ============================================
  function calculateDossierStatus(state, healthType) {
    let uploaded = 0;
    let total = 4;

    if (state.uploads.photo) uploaded++;
    // Le QS-SPORT se fait sur le site officiel FFA (pas d'upload) : compte comme réglé automatiquement
    if (healthType === 'questionnaire' || state.uploads.certificat) uploaded++;
    if (state.uploads.identity_recto) uploaded++;
    if (state.uploads.identity_verso) uploaded++;

    if (state.isForeigner) {
      total++;
      if (state.uploads.residence) uploaded++;
    }
    if (state.isMinor) {
      total += 3;
      if (state.uploads.attestation) uploaded++;
      if (state.uploads.parent_id_recto) uploaded++;
      if (state.uploads.parent_id_verso) uploaded++;
    }

    if (uploaded === 0) return '🔴 Aucun document - À compléter';
    if (uploaded < total) return '🟠 ' + uploaded + '/' + total + ' documents - À compléter';
    return '🟢 Dossier complet';
  }

  // ============================================
  // CONSTRUCTION DES ARTICLES PANIER
  // ============================================
  function buildCartItems(data, properties, state) {
    const items = [];
    const variantId = VARIANT_IDS[data.pricing];
    items.push({ id: variantId, quantity: 1, properties: properties });

    const wantsJersey = state.jerseyModel && state.jerseySize;

    if (wantsJersey) {
      const modelSizes = MAILLOT_VARIANT_IDS[state.jerseyModel];
      const jerseyVariantId = modelSizes ? modelSizes[state.jerseySize] : null;

      if (jerseyVariantId) {
        const jerseyProps = {
          '_Modèle': JERSEY_MODEL_LABELS[state.jerseyModel] || '',
          '_Taille': state.jerseySize || '',
          '_Adhérent': (properties['_Prénom'] || '') + ' ' + (properties['_Nom'] || ''),
          '_Type': 'Maillot obligatoire (+' + state.jerseyPrice + '€)'
        };
        items.push({ id: jerseyVariantId, quantity: 1, properties: jerseyProps });
      } else {
        console.error('Variante maillot introuvable pour', state.jerseyModel, state.jerseySize);
      }
    }

    return items;
  }

  // ============================================
  // SOUMISSION
  // ============================================
  function setupSubmit(form, state) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!validateStep(form, config.totalSteps, state)) return;

      const submitBtn = form.querySelector('[data-action="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = 'Envoi en cours…'; }

      const formData = new FormData(form);
      const data = {};
      formData.forEach(function(value, key) { data[key] = value; });

      const variantId = VARIANT_IDS[data.pricing];
      if (!variantId) {
        alert('Erreur : formule non reconnue. Merci de réessayer.');
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = 'Finaliser l\'inscription'; }
        return;
      }

      recalcTotal(form, state);

      const properties = {
        '_Type de demande': requestTypeLabels[state.requestType] || '',
        '_Prénom': data.firstname || '',
        '_Nom': data.lastname || '',
        '_Date de naissance': data.birthdate || '',
        '_Sexe': data.gender === 'H' ? 'Homme' : (data.gender === 'F' ? 'Femme' : ''),
        '_Ville de naissance': data.birthcity || '',
        '_Nationalité': data.nationality === 'Autre' ? (data.nationality_other || 'Autre') : data.nationality,
        '_Adresse': data.address || '',
        '_Code postal': data.postcode || '',
        '_Ville': data.city || '',
        '_Email': data.email || '',
        '_Téléphone portable': data.phone_mobile || '',
        '_Téléphone domicile': data.phone_home || 'Non renseigné',
        '_Téléphone travail': data.phone_work || 'Non renseigné',
        '_Contact urgence (nom)': data.emergency_name || '',
        '_Contact urgence (téléphone)': data.emergency_phone || '',
        '_Catégorie FFA': data.category || '',
        '_Formule': pricingLabels[data.pricing] || data.pricing || '',
        '_Prix cotisation': (state.basePrice || 0) + '€',
        '_Mode de paiement': paymentLabels[data.payment_method] || data.payment_method || '',
        '_Total payé': (state.total || 0) + '€',
        '_Statut dossier': calculateDossierStatus(state, data.health_type)
      };

      if (state.isMinor) {
        properties['_Responsable légal (nom)'] = data.parent_name || '';
        properties['_Responsable légal (téléphone)'] = data.parent_phone || '';
        properties['_Responsable légal (email)'] = data.parent_email || '';
      }

      if (state.passSportAmount > 0) properties['_Aide Pass\'Sport'] = '-' + state.passSportAmount + '€';
      if (state.carteJeuneAmount > 0) properties['_Aide Carte Jeune Provence'] = '-' + state.carteJeuneAmount + '€';

      const healthType = data.health_type;
      if (healthType === 'certificat') {
        properties['_Type justificatif santé'] = 'Certificat médical';
        if (data.cert_date) properties['_Date certificat médical'] = data.cert_date;
        properties['_Certificat médical'] = state.uploads.certificat ? state.uploads.certificat.url : '⚠️ À téléverser depuis Mon Dossier';
      } else if (healthType === 'questionnaire') {
        properties['_Type justificatif santé'] = 'Attestation QS-SPORT (remplie sur le site officiel FFA Licences)';
      }

      if (state.uploads.photo) properties["_Photo d'identité"] = state.uploads.photo.url;
      if (state.uploads.identity_recto) properties["_CNI Recto"] = state.uploads.identity_recto.url;
      if (state.uploads.identity_verso) properties["_CNI Verso"] = state.uploads.identity_verso.url;
      if (state.uploads.residence) properties['_Titre de séjour'] = state.uploads.residence.url;
      if (state.uploads.attestation) properties['_Attestation parentale'] = state.uploads.attestation.url;
      if (state.uploads.parent_id_recto) properties['_CNI Parent Recto'] = state.uploads.parent_id_recto.url;
      if (state.uploads.parent_id_verso) properties['_CNI Parent Verso'] = state.uploads.parent_id_verso.url;

      try {
        const inscriptions = JSON.parse(localStorage.getItem('uspeg_inscriptions') || '[]');
        inscriptions.push({ date: new Date().toISOString(), data: data, properties: properties });
        localStorage.setItem('uspeg_inscriptions', JSON.stringify(inscriptions));
      } catch (err) {
        console.warn('Impossible de stocker localement', err);
      }

      const cartItems = buildCartItems(data, properties, state);
      const paymentMethod = data.payment_method;

      // Chèque / espèces : on marque l'article pour que la commande créée
      // au checkout affiche clairement le mode de règlement attendu par le club.
      if (paymentMethod !== 'cb_online') {
        cartItems[0].properties['_Paiement à recevoir'] = '⚠️ ' + paymentLabels[paymentMethod];
      }

      submitToShopify(cartItems, state, submitBtn);
    });
  }

  // Tous les modes de paiement (CB, chèque, espèces) passent par le checkout
  // Shopify : c'est la SEULE étape qui crée réellement une commande dans le
  // dashboard. Pour chèque/espèces, le client choisit au checkout le mode de
  // paiement manuel "Paiement à remettre au club" (à configurer dans Réglages
  // > Paiements > Modes de paiement manuels) — aucune carte n'est demandée,
  // et la commande apparaît avec le statut "Paiement en attente".
  function submitToShopify(cartItems, state, submitBtn) {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
      })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(err) { throw new Error(err.description || 'Erreur ajout au panier'); });
        return response.json();
      })
      .then(function() {
        const discountCodes = buildDiscountCodes(state);
        applyDiscountCodesSequentially(discountCodes, 0, function() {
          window.location.href = '/checkout';
        });
      })
      .catch(function(error) {
        console.error('Erreur soumission inscription:', error);
        alert('❌ Une erreur est survenue lors de l\'ajout au panier.\n\nMerci de réessayer ou de nous contacter à uspegathle@free.fr');
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = 'Finaliser l\'inscription'; }
      });
  }

  // ============================================
  // BOOTSTRAP
  // ============================================
  function bootstrap() {
    const forms = document.querySelectorAll('[id^="inscription-form-"]');
    forms.forEach(initInscription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();